import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CaseStudy {
  institutionType: string;
  challenge: string;
  approach: string;
  outcome: string;
}

interface CaseStudyFrameworkProps {
  caseStudies: CaseStudy[];
}

const CaseStudyFramework: React.FC<CaseStudyFrameworkProps> = ({ caseStudies }) => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-6 tracking-tight">
              Program Application Across Institutional Types
            </h2>
            <p className="text-lg text-text-primary/90 max-w-3xl mx-auto leading-relaxed">
              The integrated approach adapts to different institutional contexts while maintaining systematic methodology and long-term focus.
            </p>
          </div>

          <div className="space-y-8">
            {caseStudies.map((study, index) => (
              <div
                key={index}
                className="bg-surface rounded-lg institutional-border overflow-hidden hover:institutional-shadow transition-base"
              >
                <div className="p-8 lg:p-12">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-institutional/10 rounded-md flex items-center justify-center">
                      <Icon name="BuildingOfficeIcon" size={20} className="text-institutional" />
                    </div>
                    <h3 className="text-2xl font-bold text-text-primary">
                      {study.institutionType}
                    </h3>
                  </div>

                  <div className="grid lg:grid-cols-3 gap-8">
                    <div>
                      <h4 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-3">
                        Strategic Challenge
                      </h4>
                      <p className="text-text-secondary leading-relaxed">
                        {study.challenge}
                      </p>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-3">
                        Program Approach
                      </h4>
                      <p className="text-text-secondary leading-relaxed">
                        {study.approach}
                      </p>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-3">
                        Institutional Outcome
                      </h4>
                      <p className="text-text-secondary leading-relaxed">
                        {study.outcome}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudyFramework;